module.exports = __webpack_public_path__ + "media/images/soar/site/twit-70f1c1a13046c5dc427f14bc6130eb17.svg";